import { motion } from 'framer-motion';
import LoginForm from '../components/AuthComps/LoginForm';
import PageTitle from '../components/CommonComps/Titles/PageTitle';

const Login = () => {
  // rendering login page component here
  return (
    <main className='font-lato overflow-x-hidden'>
      <PageTitle title='Login' />

      <section className='grid grid-cols-1 xl:grid-cols-2 min-h-screen'>
        <motion.div
          initial={{ x: -500, opacity: 0 }}
          animate={{
            x: 0,
            opacity: 1,
            transition: {
              ease: 'easeInOut',
              duration: 0.4,
            },
          }}
          className='relative hidden xl:block m-4 rounded-xl overflow-hidden'
        >
          <img
            className='h-full object-cover'
            src='/assets/images/legal_login.jpg'
            alt='legal sign up banner'
          />

          <div className='absolute flex items-center p-6 inset-0 bg-black/40 size-full '>
            <h1 className='text-7xl 2xl:text-8xl font-bold text-white'>
              Premium <br />{' '}
              <span className='text-legal-brown font-noto italic'>
                legal insight
              </span>
              , <br /> one login away.
            </h1>
          </div>
        </motion.div>

        <LoginForm />
      </section>
    </main>
  );
};

export default Login;
